<template>
  <div id="app">
    <div id="top">
      <div class="top">
        <ul class="list01">
          <li @click="$store.commit('changelangnum',1)">
            <img :src="$t('images.a1_02')">
          </li>
          <li class="shuxian">|</li>
          <li @click="$store.commit('changelangnum',2)">
            <img :src="$t('images.a00index1_02')">
          </li>
          <li class="shuxian">|</li>
          <li @click="$store.commit('changelangnum',3)">
            <img :src="$t('images.ff_06')">
          </li>
          <li class="topword">{{$t('text.top1')}}</li>
          <li class="topword">{{$t('text.top2')}}</li>
        </ul>
      </div>
    </div>
    <div id="log">
      <div class="log">
        <div class="log01">
          <a href="#">
            <img :src="$t('images.a00index1_03')" width="171" height="69">
          </a>
        </div>
        <div class="log02">
          <div class="log03">
            <input type="text">
          </div>
          <div class="log04">
	   <button>{{$t('text.search')}}</button>
          </div>
        </div>
      </div>
    </div>
    <div id="menu">
      <div class="menu">
        <ul class="list02">
          <li v-for="(item) in $t('title.nav')" :key="item.title">
            <router-link :to="item.path">{{item.title}}</router-link>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <router-view></router-view>
    <div id="bott">
      <div class="bott">
        <div class="bott_03">
          <div class="bott_01">
            <p>{{$t('text.bott1')}}</p>
          </div>
          <div class="bott_02">
            <!-- <asp:DropDownList
              id="DropDownList1"
              runat="server"
              AppendDataBoundItems="True"
              AutoPostBack="True"
              OnSelectedIndexChanged="DropDownList1_SelectedIndexChanged"
            >
              <asp:ListItem value="0">Ссылки</asp:ListItem>
            </asp:DropDownList>-->
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {
    this.getRouter();
  },
  methods: {
    getRouter() {
      if (this.$route.path.indexOf("en") != -1) {
        this.$i18n.locale = "en";
      } else if (this.$route.path.indexOf("ew") != -1) {
        this.$i18n.locale = "ew";
      } else if (this.$route.path.indexOf("zh") != -1) {
        this.$i18n.locale = "zh";
      }
    },
    selectNav(path) {
      switch (path) {
        case "/homezh":
          this.$router.push("/homezh");
          break;
        case "/profilezh":
          this.$router.push("/profilezh");
          break;
        case "/productzh":
          this.$router.push("/productzh");
          break;
        case "/devicezh":
          this.$router.push("/devicezh");
          break;
        case "/investzh":
          this.$router.push("/investzh");
          break;
        case "/recruitzh":
          this.$router.push("/recruitzh");
          break;
        case "/bbszh":
          this.$router.push("/bbszh");
          break;
        case "/contactzh":
          this.$router.push("/contactzh");
          break;
        case "/homeen":
          this.$router.push("/homeen");
          break;
        case "/profileen":
          this.$router.push("/profileen");
          break;
        case "/producten":
          this.$router.push("/producten");
          break;
        case "/deviceen":
          this.$router.push("/deviceen");
          break;
        case "/investen":
          this.$router.push("/investen");
          break;
        case "/recruiten":
          this.$router.push("/recruiten");
          break;
        case "/bbsen":
          this.$router.push("/bbsen");
          break;
        case "/contacten":
          this.$router.push("/contacten");
          break;
        case "/homeew":
          this.$router.push("/homeew");
          break;
        case "/profileew":
          this.$router.push("/profileew");
          break;
        case "/productew":
          this.$router.push("/productew");
          break;
        case "/deviceew":
          this.$router.push("/deviceew");
          break;
        case "/investew":
          this.$router.push("/investew");
          break;
        case "/recruitew":
          this.$router.push("/recruitew");
          break;
        case "/bbsew":
          this.$router.push("/bbsew");
          break;
        case "/contactew":
          this.$router.push("/contactew");
          break;
      }
    }
  },
  computed: {
    getLang() {
      return this.$store.state.langnum;
    }
  },
  watch: {
    getLang(val) {
      if (val == 1) {
        this.$i18n.locale = "en";
        this.$router.push("/homeen");
      } else if (val == 2) {
        this.$i18n.locale = "ew";
        this.$router.push("/homeew");
      } else if (val == 3) {
        this.$i18n.locale = "zh";
        this.$router.push("/homezh");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.router-link-active {
  background: #f600bb;
}

#top {
  background: #f7f7f7;
  width: 100%;
  margin: 0 auto;
  min-width: 1002px;

  .top {
    width: 1002px;
    margin: 0 auto;
    height: 24px;
    border-bottom: 1px solid #efefef;
    overflow: hidden;

    .list01 {
      float: right;

      .shuxian {
        color: #ec0093;
      }

      li {
        float: left;
        line-height: 24px;
        padding-left: 15px;
        cursor: pointer;
      }

      .topword {
        color: #0100fe;
      }
    }
  }
}

#log {
  background: #fff;
  width: 100%;
  margin: 0 auto;
  min-width: 1002px;
  height: 69px;

  .log {
    width: 1002px;
    margin: 0 auto;
    height: 69px;
    overflow: hidden;

    .log01 {
      float: left;
    }

    .log02 {
      float: right;
      width: 173px;
      padding-top: 29px;
      overflow: hidden;

      .log03 {
        float: left;

        input {
          background: #117fd6;
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          width: 106px;
          height: 20px;
          line-height: 18px;
          padding-left: 5px;
        }
      }

      .log04 {
        float: left;

        input {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border: 1px solid #117fd6;
          background: #fff;
          width: 62px;
          height: 20px;
          line-height: 18px;
          padding-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
}

#menu {
  background: #1579d1;
  width: 100%;
  margin: 0px auto;
  min-width: 1002px;
  height: 40px;

  .menu {
    height: 40px;
    width: 1002px;
    margin: 0px auto;

    .list02 {
      height: 40px;
      overflow: hidden;

      li {
        height: 40px;
        text-align: center;
        float: left;
        cursor: pointer;

        a {
          display: inline-block;
          width: 100%;
          height: 40px;
          overflow: hidden;
          font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
          font-size: 14px;
          line-height: 40px;
          color: #fff;
        }
      }

      li:nth-child(1) {
        width: 92px;
      }

      li:nth-child(2) {
        width: 112px;
      }

      li:nth-child(3) {
        width: 115px;
      }

      li:nth-child(4) {
        width: 183px;
      }

      li:nth-child(5) {
        width: 115px;
      }

      li:nth-child(6) {
        width: 115px;
      }

      li:nth-child(7) {
        width: 114px;
      }

      li:nth-child(8) {
        width: 112px;
      }

      li:hover {
        background: #f600bb;
      }
    }
  }
}

#bott {
  width: auto !important;
  margin: 0px auto;
  min-width: 1002px;
  overflow: hidden;

  .bott {
    width: 1002px;
    margin: 0px auto;
    height: 30px;
    line-height: 30px;
    border-top: 1px solid #d9d9d9;
    text-align: center;

    .bott_03 {
      width: 731px;
      margin: 0 auto;

      .bott_01 {
        float: left;
        width: 605px;
        color: #5d5d5d;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue